import { LitElement } from '~/lib/bn-lit-element';
import { css } from '../../utility/lit-entity';
import { DeviceMonitoringChartLayerLineMixin } from './device-monitoring-chart-layer-line-mixin';

const THRESHOLDS = { warning: 3.5, alert: 3.1 };

export const colour = css`var(--teal-20)`;
export const hasWarning = (event) => event.batVolt < THRESHOLDS.warning;
export const hasAlert = (event) => event.batVolt < THRESHOLDS.alert;

class DeviceMonitoringChartLayerBattery extends DeviceMonitoringChartLayerLineMixin(LitElement) {
  constructor() {
    super();
    this.dataKey = 'batVolt';
    this.maxValue = 4.2;
    this.minValue = 2.8;
    this.warningValue = THRESHOLDS.warning;
    this.alertValue = THRESHOLDS.alert;
  }

  static get styles() {
    return [...super.styles, css`
      :host {
        --good-stroke: var(--teal-20);
        --warning-stroke: ${colour};
        --alert-stroke: var(--teal-30);
      }
    `];
  }
}

window.customElements.define('device-monitoring-chart-layer-battery', DeviceMonitoringChartLayerBattery);
